import experiences from "../data/experiences";

export default function Experience() {
  return (
    <section id="experience" className="py-20 border-t border-line">
      <div className="container-narrow">
        <h2 className="page-heading">Experience</h2>

        <div className="space-y-12">
          {experiences.map((exp) => (
            <article key={`${exp.company}-${exp.period}`}>
              <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 mb-1">
                <h3 className="font-medium">{exp.role}</h3>
                <span className="text-sm text-muted tabular-nums shrink-0">
                  {exp.period}
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 mb-4 text-sm text-muted">
                <p>{exp.company}</p>
                <span className="shrink-0">{exp.location}</span>
              </div>

              <ul className="space-y-2 list-disc list-outside ml-4 marker:text-muted">
                {exp.points.map((p) => (
                  <li key={p} className="text-sm text-muted leading-relaxed pl-1">
                    {p}
                  </li>
                ))}
              </ul>

              {exp.links.length > 0 && (
                <div className="flex gap-4 mt-4 text-sm">
                  {exp.links.map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-link"
                    >
                      {link.label} ↗
                    </a>
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
